<template>
  <section class="section">
    <div v-if="tokenUser && tokenUser.admin" class="text-card is-size-4">
      <span class="is-size-7 w-full">Empresa seleccionada actualmente</span>
      <p class="is-size-5 has-text-weight-bold">{{ empresa.nombre }}</p>
    </div>
    <br />
    <div class="columns">
      <div class="column is-4-desktop is-12-mobile">
        <div class="box">
          <div class="content-card">
            <i class="icon-card material-icons">domain</i>
            <div class="text-card text-l">
              <span class="is-size-7 w-full">Empresas actuales</span>
              <p class="is-size-5 has-text-weight-bold">
                {{ data.companies ? data.companies.toLocaleString() : "-" }}
              </p>
            </div>
          </div>
          <div v-if="tokenUser.admin" class="content-card mt-5">
            <div class="text-card text-r">
              <span class="is-size-7 w-full">Datos seleccionados del año</span>
              <p class="is-size-5 has-text-weight-bold">
                <date-picker
                  class="datePickerYearCustom"
                  v-model="date"
                  type="year"
                  placeholder="Todos los años"
                  :editable="false"
                  :open="open"
                  @close="onCloseDatePicker"
                  @change="onChangeDatePicker"
                  :lang="es"
                  :disabled-date="disabledYears"
                >
                  <template v-slot:header="{ emit }">
                    <button
                      class="mx-btn mx-btn-text btn-header-custom"
                      :class="{ 'btn-header-custom-active': !date }"
                      @click="selectAllYears(emit)"
                    >
                      Todos los años
                    </button>
                  </template>
                </date-picker>
              </p>
            </div>
            <i
              class="icon-card material-icons datePicker"
              v-on:click="openDatePicker"
              >event</i
            >
          </div>
        </div>
      </div>
      <div class="column is-8">
        <div class="box">
          <div v-if="tokenUser.admin" class="content-card">
            <div class="text-r is-hidden-mobile">
              <i class="icon-card material-icons">filter_none</i>
            </div>
            <div class="items-header text-card columns">
              <div class="column is-3">
                <span class="is-size-7">Diagnósticos actuales</span>
                <p class="is-size-5 has-text-weight-bold">
                  {{
                    data.processTotal != null
                      ? data.processTotal.toLocaleString()
                      : "-"
                  }}
                </p>
              </div>
              <div class="divider-v is-hidden-mobile">&nbsp;</div>
              <div
                class="mx item-hover title-filter item-process column"
                :class="stylesItemProcess('climaOld')"
                v-on:click="setFilter('climaOld')"
              >
                <span class="is-size-7">ECO</span>
                <p class="is-size-5 has-text-weight-bold">
                  {{
                    data.climaOld != null ? data.climaOld.toLocaleString() : "-"
                  }}
                </p>
              </div>
              <div
                class="mx item-hover title-filter item-process column"
                :class="stylesItemProcess('clima')"
                v-on:click="setFilter('clima')"
              >
                <span class="is-size-7">Cl7</span>
                <p class="is-size-5 has-text-weight-bold">
                  {{ data.clima != null ? data.clima.toLocaleString() : "-" }}
                </p>
              </div>
              <div
                class="mx item-hover title-filter item-process column"
                :class="stylesItemProcess('frp')"
                v-on:click="setFilter('frp')"
                v-tooltip="'Factores de riesgo - v2021'"
              >
                <span class="is-size-7">FRP v21</span>
                <p class="is-size-5 has-text-weight-bold">
                  {{ data.frp != null ? data.frp.toLocaleString() : "-" }}
                </p>
              </div>
              <div
                class="mx item-hover title-filter item-process column"
                :class="stylesItemProcess('frpNew')"
                v-on:click="setFilter('frpNew')"
                v-tooltip="'Factores de riesgo  - v2023'"
              >
                <span class="is-size-7">FRP v23</span>
                <p class="is-size-5 has-text-weight-bold">
                  {{ data.frpNew != null ? data.frpNew.toLocaleString() : "-" }}
                </p>
              </div>
              <div
                class="mx item-hover title-filter item-process column"
                :class="stylesItemProcess('leader')"
                v-on:click="setFilter('leader')"
                v-tooltip="'Liderazgo PHD'"
              >
                <span class="is-size-7">Liderazgo PHD</span>
                <p class="is-size-5 has-text-weight-bold">
                  {{ data.leader != null ? data.leader.toLocaleString() : "-" }}
                </p>
              </div>
              <div
                class="mx item-hover title-filter item-process column"
                :class="stylesItemProcess('cultura')"
                v-on:click="setFilter('cultura')"
              >
                <span class="is-size-7">Cultura</span>
                <p class="is-size-5 has-text-weight-bold">
                  {{
                    data.cultura != null ? data.cultura.toLocaleString() : "-"
                  }}
                </p>
              </div>
            </div>
          </div>
          <div v-if="!tokenUser.admin" class="content-card">
            <div class="text-card is-size-4">
              <span class="is-size-7 w-full"
                >Empresa seleccionada actualmente</span
              >
              <p class="is-size-5 has-text-weight-bold">{{ empresa.nombre }}</p>
            </div>
          </div>
        </div>
        <div
          v-if="tokenUser.admin"
          style="border-bottom: 1px solid #cbcbcb; padding-bottom: 0.5px;"
        >
          <div
            class="content-graph"
            :class="{ 'load-graph': !this.data.companiesByDate }"
          >
            <graph-apex-chart
              v-if="this.data.companiesByDate"
              :data="graphBar(this.data.companiesByDate)"
              :change="updateGraph"
            ></graph-apex-chart>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapState } from "vuex";
import GraphApexChart from "../../dashboard/GraphApexChart.vue";
import DatePicker from "vue2-datepicker";
import es from "vue2-datepicker/locale/es";
import "vue2-datepicker/index.css";

export default {
  data() {
    return {
      open: false,
      date: null,
      updateGraph: 0,
      es,
      months: [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ],
      colors: [
        "#532687",
        "#653697",
        "#764697",
        "#875797",
        "#976897",
        "#A77A97",
        "#B88C97",
        "#C89E97",
        "#D9B097",
        "#E9C297",
      ],
    };
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    filter: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    ...mapState(["tokenUser", "empresa"]),
  },
  methods: {
    graphBar(companiesByDate) {
      try {
        let series = [
          {
            name: "Empresas",
            data: [21, 22, 10, 28, 16, 21, 13, 30, 20, 5, 0, 2, 12, 15, 1, 20],
          },
        ];

        let categories = [
          "Empresa 1",
          "Empresa 2",
          "Empresa 3",
          "Empresa 4",
          "Empresa 5",
          "Empresa 6",
          "Empresa 7",
          "Empresa 8",
          "Empresa 9",
          "Empresa 10",
          "Empresa 11",
          "Empresa 12",
          "Empresa 13",
          "Empresa 14",
          "Empresa 15",
          "Empresa 16",
        ];
        if (companiesByDate) {
          const defaulData = Array(12).fill(0);
          categories = this.months;
          if (this.date) {
            series = [
              {
                name: "Empresas",
                data: defaulData,
              },
            ];

            companiesByDate.map((element) => {
              series[0].data[parseInt(element._id) - 1] = parseInt(
                element.companies
              );
            });
          } else {
            series = {};
            companiesByDate.map((element) => {
              const year = element.year;
              const monthIndex = parseInt(element.month) - 1;
              const companies = parseInt(element.companies);
              if (!series[year]) {
                series[year] = {
                  name: year,
                  data: [...defaulData],
                };
              }

              series[year].data[monthIndex] = companies;
            });
            series = Object.values(series);
          }
        }

        const graph = {
          series,
          options: {
            chart: {
              width: "100%",
              height: "50px",
              redrawOnParentResize: true,
              redrawOnWindowResize: false,
              type: "bar",
              toolbar: {
                show: false,
              },
              sparkline: {
                enabled: true,
              },
              events: {
                click: (event, chartContext, w) =>
                  this.setFilter(w.config.xaxis.categories[w.dataPointIndex]),
              },
            },
            states: {
              active: {
                filter: {
                  type: "darken",
                  value: 0.15,
                },
              },
              hover: {
                filter: {
                  type: "darken",
                  value: 0.5,
                },
              },
            },
            plotOptions: {
              bar: {
                // borderRadius: 5,
                columnWidth: this.date ? "35%" : "90%",
                distributed: false,
                barHeight: "100%",
              },
            },
            dataLabels: {
              enabled: false,
            },
            colors: this.colors,
            tooltip: {
              enabled: true,
              shared: false,
              intersect: true,
              y: {
                formatter: function(value) {
                  return Math.round(value);
                },
              },
            },
            legend: {
              show: false,
            },
            xaxis: {
              categories,
              labels: {
                show: false,
              },
              axisBorder: {
                show: false,
              },
              axisTicks: {
                show: false,
              },
            },
            yaxis: {
              labels: {
                show: false,
              },
              axisBorder: {
                show: false,
              },
              axisTicks: {
                show: false,
              },
            },
            grid: {
              show: false,
            },
          },
          width: "100%",
          type: "bar",
        };

        return graph;
      } catch (error) {
        console.log(error);
      }
    },
    setFilter(value) {
      this.$emit("setFilter", value);
    },
    stylesItemProcess(type) {
      if (Object.keys(this.filter).length && this.filter.value === type) {
        return "item-hover-select";
      }
      return "";
    },
    // Date Picker
    openDatePicker() {
      if (!this.open) this.open = true;
    },
    onCloseDatePicker() {
      this.open = false;
    },
    onChangeDatePicker(date) {
      this.$emit("setDate", date);
    },
    selectAllYears(emit) {
      emit(null);
      this.open = false;
    },
    disabledYears(date) {
      if (this.data.rangeDates) {
        const min = new Date(this.data.rangeDates.minDate);
        const max = new Date(this.data.rangeDates.maxDate);
        return date < min || date > max;
      }
      return date > new Date();
    },
  },
  components: {
    GraphApexChart,
    DatePicker,
  },
  watch: {
    data: {
      deep: true,
      handler: function(nv) {
        this.updateGraph = this.updateGraph ? 0 : 1;
      },
    },
    filter(nv) {
      // if(!Object.keys(this.filter).length || !this.months.includes(this.filter.value)) this.updateGraph = this.updateGraph ? 0 : 1;
    },
  },
};
</script>
<style lang="scss" scoped>
.mb-5 {
  margin-bottom: 10px;
}
.mt-5 {
  margin-top: 10px;
}
.mx {
  margin: auto;
}
.section {
  padding: 0.5rem 1.5rem 0 !important;
}
.icon-card {
  padding: 10px;
  border-radius: 5px;
  background-color: #4a227b;
  color: white;
}
.content-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.text-card {
  padding: 5px 10px;
  border-radius: 10px;
  background-color: #f3f3f3;
  width: 100%;
}
.text-l {
  text-align: left;
  margin-left: 15px;
  padding-left: 25px;
}
.text-r {
  text-align: right;
  margin-right: 15px;
  padding-right: 25px;
}

.w-full {
  width: 100%;
  display: block;
}

.divider-v {
  height: 60px;
  width: 3px;
  border-radius: 40px;
  margin: auto;
  background-color: #4a227b;
  content: "";
}

.content-graph {
  max-height: 50px;
  // border-bottom: 1px solid #cbcbcb;
}

.load-graph {
  background-color: #d5d5d5;
  border-radius: 10px;
}

.title-filter {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.item-process {
  text-align: center;
  width: 94px !important;
  margin: auto 5px !important;
  transition: all 0.5s;
}

@media screen and (max-width: 768px) {
  .item-process {
    margin: auto 0 !important;
  }
  .items-header {
    text-align: center !important;
  }
  .content-card {
    justify-content: center !important;
  }
}

.item-hover:hover {
  border-radius: 10px;
  background-color: #cbcbcb !important;
  color: currentColor !important;
  cursor: pointer;
  transition: all 0.5s;
}

.item-hover-select {
  border-radius: 10px;
  background-color: #4a227b !important;
  color: white !important;
  cursor: pointer;
  transition: all 0.5s;
}

.items-header .column {
  padding: 5px !important;
}
.items-header .column.is-3 {
  width: 22% !important;
}

.datePicker:hover {
  cursor: pointer !important;
  background-color: #6600a9 !important;
  border-radius: 5px !important;
}
</style>
<style lang="scss">
.mx-input {
  text-align: end;
  display: inline-table;
  border: none;
  padding: 0;
  font-weight: 700 !important;
  font-size: 1.25rem !important;
  box-shadow: none;
  background-color: transparent;
  color: currentColor;
}

.mx-icon-calendar,
.mx-icon-clear {
  display: none !important;
}

.mx-datepicker-main table td:not([align]),
table th:not([align]) {
  text-align: center !important;
}

.mx-calendar-content .cell.active {
  color: #fff;
  background-color: #532687 !important;
  border-radius: 5px !important;
}

.mx-calendar-content .cell:hover {
  color: #532687 !important;
  background-color: #fcf3fe !important;
}

.mx-btn-text:hover {
  color: #532687 !important;
  background-color: #fcf3fe !important;
  border-radius: 5px !important;
}

.btn-header-custom {
  width: 100%;
  text-align: center;
}

.btn-header-custom-active {
  background-color: #532687 !important;
  color: white !important;
}

.btn-header-custom-active:hover {
  color: #73879c !important;
  background-color: #fcf3fe !important;
}
</style>



// WEBPACK FOOTER //
// src/components/empresas/layaout/Header.vue